import React from "react";
import styles from "./chat-buddy-common.module.less";
import { BuddyCommonProps } from "../../types/chat-msg-types";
import ChatTime from "../chat-time";

const ChatBuddyCommon:React.FC<BuddyCommonProps> = (props: BuddyCommonProps) => {
    return(
        <div className={styles.ChatBuddyCommonLess}>
            <div className="chat-buddy-common" dangerouslySetInnerHTML={{__html:props.buddyCommon as string }}></div>
            <ChatTime date={props.date}></ChatTime>
        </div>
    )
}

export default ChatBuddyCommon;